/**
 * Labstep
 *
 * @module components/Resource/Action/View
 * @desc Button linking to resource show
 */

import EntityActionView from 'labstep-web/components/Entity/Action/View';
import { Resource } from 'labstep-web/models/resource.model';
import type React from 'react';
import type { IResourceActionViewProps } from './types';

export const ResourceActionView: React.FC<
  IResourceActionViewProps
> = ({ resource, actionComponentProps }) => (
  <EntityActionView
    entityName={Resource.entityName}
    params={{ id: resource.id }}
    actionComponentProps={actionComponentProps}
  />
);
